define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class CPIService
     */
    function CPIService(orderService) {
        var self = this;

        self.suppliers = [
            {
                name: 'AEM-Soft',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Autre',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Axone',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Bimedia',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Casio',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'CPI presse',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Crisalid',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Devlyx-ABM',
                isPress: true,
                isTobacco: true,
                isBookShop: true,
                isStationery: true,
                isTaxable: true
            },
            {
                name: 'Devlyx-Autre',
                isPress: true,
                isTobacco: true,
                isBookShop: true,
                isStationery: true,
                isTaxable: true
            },
            {
                name: 'Devlyx-JDC',
                isPress: true,
                isTobacco: true,
                isBookShop: true,
                isStationery: true,
                isTaxable: true
            },
            {
                name: 'Inconnu',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Non informatisé',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'OMC Gervais',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Sharp',
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            },
            {
                name: 'Strator',
                isPress: true,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false
            }
        ];
        /**
         * print using the window object method
         * @method printCPI
         */
        self.printCPI = function printCPI() {
            window.print();
        };

        /**
         * Get CPI object
         * @return {Object}
         */
        self.getCPIObject = function getCPIObject() {
            return {
                actualEquipment: null,
                wishedInstallDay: null,
                isStoreWillBeClosed: false,
                isWorks: false,
                isCloseInternetConnection: false,
                boxDistance: null,
                nbFreeBoxEthernetPorts: null,
                isFixedIP: false,
                isOdeolis: false,
                odeolisReason: null,
                nbSockets: '1',
                isServer: false,
                isReleased: false,
                comment: null,
                isDeloitte: false,
                isMPDV: false,
                isSpacesVerified: false,
                isRecovery: false,
                isPress: false,
                isTobacco: false,
                isBookShop: false,
                isStationery: false,
                isTaxable: false,
                isSwitch: false,
                isDrilling: false,
                dateEndWorks: null,
                wishedInstallationDate: null,
                wishedInstallationMoment: null,
                wishedPreVisitDate: null,
                isVirtualTill: false,
                isLoanScanner: false,
                formation: 'service',
                fel: null,
                optionCommande: null,
                bConnectedInfo: {
                    "local": {
                        "groundFloor": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "basement": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "reserve": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "stage1": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "stage2": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "terrace": {
                            "surface": null,
                            "length": null,
                            "width": null,
                        },
                        "wallThickness": null,
                        "distanceTerracePos": null
                    },
                    "network": {
                        "location": null,
                        "accessType": {
                            "c1": null,
                            "c2": null,
                            "c3": null,
                            "c4": null,
                            "c5": null,
                            "c6": null,
                            "print1": null,
                            "print2": null,
                            "print3": null,
                            "print4": null,
                            "print5": null,
                            "print6": null,
                        },
                        "distanceRouter": {
                            "c1": null,
                            "c2": null,
                            "c3": null,
                            "c4": null,
                            "c5": null,
                            "c6": null,
                            "print1": null,
                            "print2": null,
                            "print3": null,
                            "print4": null,
                            "print5": null,
                            "print6": null,
                        },
                        "nbSocket": null,
                        "isIdentified": false
                    }
                },
                fai: null,
                autreFai : null,
                isMall: false,
                codeDebit: null
            };
        };

        /**
         * Save the CPI
         * @param  {int} orderId
         * @param  {Object} cpi
         * @return {Promise}
         */
        self.save = orderService.saveCPI;

        /**
         * Publish the CPI
         * @param  {Object} order
         * @return {Promise}
         */
        self.publish = orderService.publishCPI;

        /**
         * Delete an unpublished CPI
         * @param  {Object} order
         * @return {Promise}
         */
        self.deleteCPI = orderService.deleteCPI;

        return self;
    }

    CPIService.$inject = ['orderService'];

    angular.module('app.bdc.cpi.cpiService', []).factory('cpiService', CPIService);
});
